var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEmpty = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 365.329,
    height: 140.67,
    viewBox: "0 0 365.329 140.67",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#98b7b7",
    stopOpacity: 0.161
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298,
    stopColor: "#cbdbdb",
    stopOpacity: 0.169
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffefe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.484,
    y1: 0.049,
    x2: 0.491,
    y2: 0.821,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3748",
    "data-name": "Group 3748",
    transform: "translate(3 -216.108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3727",
    "data-name": "Group 3727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3726",
    "data-name": "Group 3726"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56208",
    "data-name": "Path 56208",
    d: "M2788.2,2558.3a145.965,145.965,0,0,0,16.348-12.882c6.959-6.3,14.04-16.026,26.495-15.293,12.537.737,22.724,13.478,35.542,21.325a131.154,131.154,0,0,0,31.105,13.292Z",
    transform: "translate(-2714.364 -2268.988)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56211",
    "data-name": "Path 56211",
    d: "M2788.2,2558.3a145.965,145.965,0,0,0,16.348-12.882c6.959-6.3,14.04-16.026,26.495-15.293,12.537.737,22.724,13.478,35.542,21.325a131.154,131.154,0,0,0,31.105,13.292Z",
    transform: "translate(-2535.364 -2268.988)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56209",
    "data-name": "Path 56209",
    d: "M2759.364,2577.217s7.525-1.083,19.9-8.465c12.018-7.174,28.682-23.5,47.127-22.493,20.742,1.133,34.885,15.59,50.341,25.707,10.409,6.812,26.179,13.1,26.179,13.1Z",
    transform: "translate(-2762.364 -2272.988)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56210",
    "data-name": "Path 56210",
    d: "M2759.364,2577.217s7.525-1.083,19.9-8.465c12.018-7.174,28.682-23.5,47.127-22.493,20.742,1.133,34.885,15.59,50.341,25.707,10.409,6.812,26.179,13.1,26.179,13.1Z",
    transform: "translate(-2583.364 -2272.988)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "package",
    transform: "translate(105.899 229.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56216",
    "data-name": "Path 56216",
    d: "M240.995,0h7.888V26.34h-7.888Z",
    transform: "translate(-177.621 -9.582)",
    fill: "#43756a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56221",
    "data-name": "Path 56221",
    d: "M240.995,0h7.888V26.34h-7.888Z",
    transform: "translate(-177.621 -13)",
    fill: "#98b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56217",
    "data-name": "Path 56217",
    d: "M0,0H7.888V26.34H0Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 26.279, 2.471)",
    fill: "#43756a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56222",
    "data-name": "Path 56222",
    d: "M0,0H7.888V26.34H0Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 26.279, -0.947)",
    fill: "#98b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56218",
    "data-name": "Path 56218",
    d: "M0,0H26.34V7.888H0Z",
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 88.355, 21.34)",
    fill: "#43756a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56220",
    "data-name": "Path 56220",
    d: "M0,0H26.34V7.888H0Z",
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 88.355, 17.922)",
    fill: "#98b7b7"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_56226",
    "data-name": "Path 56226",
    d: "M117.494,167.007,67.318,150.375,17.143,167.007.01,194.221l15.772,5.228v28.925l51.536,17.083,51.536-17.083V199.449l15.772-5.228Zm-15.119,3.3L67.318,181.927,32.262,170.306l35.057-11.621ZM12.051,189.9l9.368-14.88,39.88,13.22-9.367,14.88Zm11.62,12.162,31.643,10.489,8.06-12.8v36.09l-39.7-13.161ZM71.263,235.84V199.75l8.06,12.8,31.643-10.489v20.615Zm11.444-32.718-9.367-14.88,39.88-13.22,9.368,14.88Z",
    transform: "translate(105.899 108.69)",
    fill: "#43756a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56227",
    "data-name": "Path 56227",
    d: "M117.494,167.007,67.318,150.375,17.143,167.007.01,194.221l15.772,5.228v28.925l51.536,17.083,51.536-17.083V199.449l15.772-5.228Zm-15.119,3.3L67.318,181.927,32.262,170.306l35.057-11.621ZM12.051,189.9l9.368-14.88,39.88,13.22-9.367,14.88Zm11.62,12.162,31.643,10.489,8.06-12.8v36.09l-39.7-13.161ZM71.263,235.84V199.75l8.06,12.8,31.643-10.489v20.615Zm11.444-32.718-9.367-14.88,39.88-13.22,9.368,14.88Z",
    transform: "translate(105.899 111.32)",
    fill: "#98b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56228",
    "data-name": "Path 56228",
    d: "M3264.427,2549.254l-3.564-2.34a142.768,142.768,0,0,1-1.79-14.3,131.265,131.265,0,0,1-.269-15.429c.143-.563,1.926-.3,1.926-.3s-.955-2.43-.621-3.24l.961-.48,1,.48a10.025,10.025,0,0,1-.825,3.24s1.546-.391,1.784.639-.605,4.351,0,7.779.32,4.185,2.422,5.294,3.182-.517,5.093,2.451,4.352,6.666,3.824,10-6.188,3.212-6.188,3.212l-9.1,3.544a7.89,7.89,0,0,1-2.288-1.032c-.33-.437.967-.715.967-.715l1.321-.515,4.349-2.489,8.034-2.006s2.619,8.992,1.3,8.992Z",
    transform: "translate(-3113.364 -2265.988)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56229",
    "data-name": "Path 56229",
    d: "M5967.475,2538.594s.359,3.786-1.677,6.01-7.018,4.752-7.018,4.752-2.583.641-2.866,1.207.449,1.351,1.3,1.351,2.1-1.351,2.1-1.351,1.915,1.139,5.214-.332,5.271-2.636,7.136-4.948a4.58,4.58,0,0,0,.813-1.553,3.123,3.123,0,0,0-.493-2.746Z",
    transform: "translate(-5813.364 -2266.988)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56230",
    "data-name": "Path 56230",
    d: "M5967.322,2536.671l-2.743-.488s.174-3.075-.13-3.563-.983-.535-1.256-1.356a2.992,2.992,0,0,1,0-2.349c.365-.67.471-.689,1.383-1.407s1.044-1.218,2.232-1.112,1.913.416,2.522,2.047.254,1.843-.355,2.91-1.839.93-2.083,1.357S5967.322,2536.671,5967.322,2536.671Z",
    transform: "translate(-4508.917 -4238.716) rotate(21)",
    fill: "#e5e5e5"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmpty, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/empty.43c5f24c.svg";
export { ForwardRef as ReactComponent };